import styled from 'styled-components';

import { styledTypography } from '@pkg/primitives';

export const DataDisplayTable = styled.div`
    display: grid;
    width: 100%;
    grid-template-columns: 1fr 5fr;
    grid-auto-rows: minmax(25px, max-content);
    grid-gap: 5px;
    border-bottom: 1px solid ${({ theme }) => theme.shades.white[10]};
`;

export const CriteriaTable = styled.div`
    display: grid;
    grid-template-rows: minmax(20px, max-content) max-content;
`;

export const DataDisplay = styled.div<{ $isTitle?: boolean }>`
    ${styledTypography.allianceBase};
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
    grid-auto-rows: max-content;
    padding: 6px 0;
    font-weight: ${({ $isTitle }) => ($isTitle ? 700 : 400)};
    text-transform: capitalize;
    place-content: flex-start;
    place-items: flex-start;
    span {
        margin: 4px 0;
        font-weight: 700;
        font-size: 14px;
        letter-spacing: -0.6px;
        text-transform: uppercase;
        color: ${({ theme }) => theme.shades.white[50]};
    }
    svg {
        display: flex;
        fill: currentColor;
        width: 20px;
    }
`;
export const GameActionsWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 10px 0;
    gap: 5px;
`;
export const GameActionsContent = styled.div`
    display: flex;
    gap: 5px;
`;
